import React from 'react';
import { Globe } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-navy-950 pt-10 pb-16 px-4 border-t border-navy-800" data-id="element-130">
      <div className="max-w-6xl mx-auto text-center" data-id="element-131">
        <div className="flex items-center justify-center space-x-2 text-gold-400 font-serif font-bold text-2xl mb-6" data-id="element-132">
          <Globe className="w-6 h-6" data-id="element-133" />
          <span data-id="element-134">MUNDO PRÁCTICO™</span>
        </div>

        <p className="text-gray-200 max-w-md mx-auto mb-2" data-id="element-135">
          El sistema de crianza práctica N°1 para familias argentinas con hijos
          de 1 a 7 años.
        </p>
        <p className="text-gray-300 italic mb-12" data-id="element-136">
          Porque criar bien no debería costarte todos los domingos del año.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-200 mb-12" data-id="element-137">
          <a href="mailto:mundopractico.oficial@gmail.com" className="hover:text-gold-400 transition-colors" data-id="element-138">
            📧 mundopractico.oficial@gmail.com
          </a>
          <a href="https://mundopractico.online" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-139">
            🌐 mundopractico.online
          </a>
        </div>

        <div className="border-t border-navy-800 pt-8 flex flex-col items-center" data-id="element-140">
          <p className="text-xs text-gray-400 mb-6" data-id="element-141">
            © Mundo Práctico™ 2026 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-yellow-400 font-serif italic text-xl md:text-2xl mt-2 drop-shadow-[0_0_15px_rgba(250,204,21,0.3)]" data-id="element-142">
            "El próximo berrinche puede terminar diferente." — Mundo Práctico
          </p>
        </div>
      </div>
    </footer>;
};